const ecards = {
  portugues: {
    title: 'E-cards',
    subTitle1: 'Escolha o seu e compartilhe. ',
    subTitle2: 'Veja abaixo os e-cards em destaque.',
    shootModel: 'Compartilhe agora',
    labelEmail: 'Seu e-mail',
    labelName: 'Seu nome',
    labelEmailRecipient: 'Email do destinatário',
    labelRecipientName: 'Nome do destinatário',
    labelMessage: 'Mensagem',
    button: 'Enviar e-card'
  },
  ingles: {
    title: 'E-cards',
    subTitle1: 'Choose yours and share.',
    subTitle2: 'See the featured e-cards below.',    
    shootModel: 'Share Now',
    labelEmail: 'Your email',
    labelName: 'Your name',
    labelEmailRecipient: "Recipient's email",
    labelRecipientName: 'Recipient name',
    labelMessage: 'Message',
    button: 'Send e-card'
  }
}

export default ecards
